var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import LocalStorageService from "@ane/core/lib/services/LocalStorageService";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { USER_FIELD } from "@ane/core/lib/constants/QueryString.constants";
import { CHECK_GROUP_LOCAL_STORAGE_KEY } from "./AnEGroup.constants.js";
class TASServiceInstance {
  constructor() {
    /***
     * Check whether the current user is in the AnE Group
     * no user data in local storage returns null
     */
    __publicField(this, "isAnEGroupMember", () => {
      var _a, _b, _c;
      const alias = (_c = (_b = EnvironmentService.getQueryParam(USER_FIELD)) != null ? _b : (_a = EnvironmentService.getUser()) == null ? void 0 : _a.alias) != null ? _c : "";
      const data = LocalStorageService.getItem(CHECK_GROUP_LOCAL_STORAGE_KEY);
      return !!data && data.user === alias ? data.isAneGroupMember : null;
    });
    __publicField(this, "setAnEGroupMember", (payload) => {
      const { user, isAneGroupMember } = payload;
      LocalStorageService.setItem(CHECK_GROUP_LOCAL_STORAGE_KEY, {
        user,
        isAneGroupMember
      });
    });
  }
}
const TASService = new TASServiceInstance();
export {
  TASService,
  TASServiceInstance,
  TASService as default
};
//# sourceMappingURL=TASService.js.map
